import React from 'react';
import styled from 'styled-components';
import ModalCenter from '@/common/components/modal/ModalCenter';
import { Button } from '@/common/components/button/Button';
import { typography } from '@/common/styles/typography';

interface AICompanyInfoModalProps {
  isOpen: boolean;
  onClose: () => void;
  onAIConfirm: () => void;
  onManualConfirm: () => void;
}

export const AICompanyInfoModal: React.FC<AICompanyInfoModalProps> = ({
  isOpen,
  onClose,
  onAIConfirm,
  onManualConfirm
}) => {
  return (
    <ModalCenter
      isOpen={isOpen}
      onClose={onClose}
      title="AI로 기업 정보를 확인하세요!"
      maxWidth="380px"
      footer={
        <FooterButtonGroup>
          <Button
            $size="md"
            $variant="outline"
            onClick={onManualConfirm}
            style={{ flex: 1 }}
          >
            아니오, 직접 작성할래요.
          </Button>
          <Button
            $size="md"
            $variant="fill"
            onClick={onAIConfirm}
            style={{ flex: 1 }}
          >
            네, AI기능을 사용할게요.
          </Button>
        </FooterButtonGroup>
      }
    >
      <ContentWrapper>
        
        <Description>
        팩트시트에 오신 것을 환영합니다! <br/>
        정보보호를 위해 기업 정보 확인이 필요합니다.<br /> AI 기능을 사용하시면 사업자등록증 사본 파일 업로드 만으로 간편하게 확인하실 수 있어요. <br/>
        AI기능을 사용해보시겠어요?
        </Description>
      </ContentWrapper>
    </ModalCenter>
  );
};

const ContentWrapper = styled.div`
  padding: 1.5rem;
  text-align: center;
`;

const TitleSection = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 12px;
  margin-bottom: 16px;
`;

const AIIcon = styled.div`
  width: 32px;
  height: 32px;
  border-radius: 50%;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  font-weight: bold;
  font-size: 14px;
  
  &::before {
    content: 'AI';
  }
`;

const Title = styled.h3`
  margin: 0;
  font-size: 18px;
  font-weight: 600;
  color: #333;
`;

const Description = styled.p`
  ${typography.body1}
  margin: 0 0 20px;
`;

const BenefitsList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  text-align: left;
  margin-bottom: 8px;
`;

const BenefitItem = styled.div`
  font-size: 13px;
  color: #555;
  display: flex;
  align-items: center;
  
  &::before {
    content: '✓';
    color: #1972EA;
    font-weight: bold;
    margin-right: 8px;
  }
`;

const FooterButtonGroup = styled.div`
  display: flex;
  gap: 12px;
  width: 100%;
`; 